import { z } from 'zod'

export const identitySchema = z.object({
  name: z.string().trim().min(2, 'نام پروژه الزامی است'),
  code: z.string().trim().max(32, 'کد پروژه طولانی است').optional(),
  icon: z.string().optional(),
  color: z.string().regex(/^#[0-9a-fA-F]{6}$/, 'رنگ نامعتبر است'),
})

export const metadataSchema = z.object({
  description: z.string().max(2000).optional(),
  department: z.string().max(120).optional(),
  principal_investigator: z.string().max(120).optional(),
  institution: z.string().max(160).optional(),
  irb_reference: z.string().max(120).optional(),
})

export const scheduleSchema = z
  .object({
    start_date: z.string().optional(),
    end_date: z.string().optional(),
    time_zone: z.string().min(1),
    default_language: z.string().min(1),
    default_calendar: z.enum(['jalali', 'gregorian']),
    data_retention_policy: z.string().max(500).optional(),
    status: z.enum(['active', 'paused', 'closed', 'archived']),
  })
  .refine(
    (v) => {
      if (!v.start_date || !v.end_date) return true
      return new Date(v.end_date) >= new Date(v.start_date)
    },
    { message: 'پایان باید بعد از شروع باشد', path: ['end_date'] },
  )

export const memberSchema = z.object({
  user_id: z.string().uuid(),
  role: z.enum(['admin', 'data_entry', 'approver', 'viewer']),
})

export const membersSchema = z.object({
  initial_admin_id: z.string().uuid('انتخاب ادمین الزامی است'),
  extra_members: z.array(memberSchema),
})

export type IdentityValues = z.infer<typeof identitySchema>
export type MetadataValues = z.infer<typeof metadataSchema>
export type ScheduleValues = z.infer<typeof scheduleSchema>
export type MembersValues = z.infer<typeof membersSchema>
